import {UntypedFormArray, ValidatorFn} from '@angular/forms';

export type FormControls<T> = {
  [K in keyof Partial<T>]:
    | [T[K] | {value: T[K]; disabled: boolean}, ValidatorFn[]?]
    | UntypedFormArray;
};
